import {useControllers} from '../../../../../common/helpers/react/hooks/useControllers';
import DefaultTable, {ServerPagingConfig} from '../../../common/components/table/DefaultTable';
import {useHistoryTableColumns} from './useHistoryTableColumns';
import {toServerSortingConfig} from '../../../common/components/table/helpers/toServerSortingConfig';

export const HistoryTable = () => {
    const history = useControllers().history;
    const columns = useHistoryTableColumns();
    const data = history.getHistory$().useState() ?? [];
    const isBusy = history.isBusy$().useState() !== false;
    const sortingState = history.getHistorySortingState$().useState();
    const sorting = toServerSortingConfig(
        sortingState,
        (sortBy, sortOrder) =>
            history.changeHistorySorting(sortBy, sortOrder)
    );
    const pagingState = history.getHistoryPagingState$().useState();
    const paging: ServerPagingConfig | undefined = pagingState
        ? {
            page: pagingState.page,
            pageSize: pagingState.pageSize,
            totalRecords: pagingState.totalRecords,
            onPageChange: page => history.loadPage(page),
            onPageSizeChange: pageSize => history.changePageSize(pageSize)
        }
        : undefined;

    return <DefaultTable
        className={'spark-mar-t-2'}
        columns={columns}
        data={data}
        isBusy={isBusy}
        sorting={sorting}
        paging={paging}
    />;
};
